import React from "react";
import CalendarDropoff from "../../../component/Calendar/CalendarDropoff";


const CalendarDropoffScreen = () => {
  return (
    <div>
      <CalendarDropoff />
    </div>
  );
};

export default CalendarDropoffScreen;
